export const CACHE_DATA = 'CACHE_DATA';
export const RECORD_LRU_INDEX = 'RECORD_LRU_INDEX';
export const CLEAR_CACHE = 'CLEAR_CACHE';
export const SET_MAX_CACHE_SIZE = 'SET_MAX_CACHE_SIZE';

export function setMaxCacheSize(context, maxSize, destructor) {
  return {
    type: SET_MAX_CACHE_SIZE,
    context,
    maxCacheSize: maxSize,
    destructor,
  };
}

export function cacheData(context, key, data, destructor) {
  return {
    type: CACHE_DATA,
    context,
    key,
    data,
    destructor,
  };
}

export function loadData(context, key) {
  return (dispatch, getState) => {
    const cache = getState().cache[context].cache;

    let data = null;
    for (const [index, cacheEntry] of cache.entries()) {
      if (cacheEntry.key === key) {
        data = cacheEntry.data;
        dispatch(recordLruIndex(context, index));
        break;
      }
    }

    return data;
  };
}

function recordLruIndex(context, index) {
  return {
    type: RECORD_LRU_INDEX,
    context,
    index,
  };
}

export function clearCache(context, destructor) {
  return {
    type: CLEAR_CACHE,
    context,
    destructor,
  };
}



// WEBPACK FOOTER //
// ./src/actions/cache.js